"use client";

import React, { useEffect, useState } from "react";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";

interface ClientHeaderScrollEffectProps {
  children: React.ReactNode;
  bannerSlot?: React.ReactNode;
}

const ClientHeaderScrollEffect: React.FC<ClientHeaderScrollEffectProps> = ({ children, bannerSlot }) => {
  const [scrolled, setScrolled] = useState(false);
  const isMobile = useMediaQuery("(max-width:991px)");
  const isDesktop = !isMobile;
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Note: Banner height CSS variable is managed by useBannerHeight hook in PromotionalBannerClient
  // This component just renders the banner in the appropriate location

  return (
    <>
      <Stack
        sx={{
          position: "fixed",
          top: 0,
          zIndex: 1000,
          width: "100%",
          height: "auto",
          display: "block",
          backgroundColor: "primary.main",
          marginTop: scrolled && !isMobile ? "-5rem" : 0,
          transition: "margin-top 0.3s"
        }}
      >
        {children}
        {isDesktop && bannerSlot && (
          <Box
            sx={{
              width: "100%"
            }}
          >
            {bannerSlot}
          </Box>
        )}
      </Stack>
      {!isDesktop && bannerSlot && (
        <Box
          sx={{
            width: "100%",
            position: "relative",
            zIndex: 10,
            mt: { legacyMobile: "75px" }
          }}
        >
          {bannerSlot}
        </Box>
      )}
    </>
  );
};

export default ClientHeaderScrollEffect;
